module.exports = __webpack_public_path__ + "media/images/smart_phone/rank/icon_rank5-24f7deab8e14dd05704e4431b46e521d.png";